
import moment from 'moment'
import { Label, FleetIcon } from 'frame/components'
import { useNavigate, useLocation } from 'react-router-dom'
import { getDateColor, obfuscateAgreementNumber } from 'listable'
import { types } from '../../module'
import { useEnabledFeatureToggleList } from 'features/settings'

import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'

import TableCellView from 'frame/components/table-cell/table-cell'
import { themeV5 } from 'theme/v5'

const Row = ({ item, columns }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const featureToggleList = useEnabledFeatureToggleList()
  const tfp1938FeatureToggle = featureToggleList.includes('TFP1938')

  const onViewDocumentsReport = () => {
    navigate(`/reports/documents?registration=${item.registration}`, { label: 'Upcoming Maturities', path: location.pathname })
  }

  return (
    <TableRow
      hover
      sx={{
        boxSizing: 'border-box',
        verticalAlign: 'middle',
        height: '30px',
        borderBottom: '5px solid white',
      }}>
      <TableCell sx={{ bgcolor: 'white', width: '10px', p: 0 }} />
      {columns.accountName && (
        <TableCellView isFirst>
          <FleetIcon fleetName={item.accountName} />
        </TableCellView>
      )}
      {columns.agreementNo && (
        <TableCellView>
          {obfuscateAgreementNumber(item.agreementNo || '-', true)}
        </TableCellView>
      )}
      {columns.registration && (
        <TableCellView>
          {item.registration || '-'}
        </TableCellView>
      )}
      {columns.assetBranch && tfp1938FeatureToggle && (
        <TableCellView>
          {item.assetBranch || '-'}
        </TableCellView>
      )}
      {columns.assetFunction && tfp1938FeatureToggle && (
        <TableCellView>
          {item.assetFunction || '-'}
        </TableCellView>
      )}
      {columns.year && (
        <TableCellView>
          {item.year || '-'}
        </TableCellView>
      )}
      {columns.make && (
        <TableCellView>
          {item.make || '-'}
        </TableCellView>
      )}
      {columns.model && (
        <TableCellView>
          {item.model || '-'}
        </TableCellView>
      )}
      {columns.variant && (
        <TableCellView>
          {item.variant || '-'}
        </TableCellView>
      )}
      {columns.fuelType && (
        <TableCellView>
          {item.fuelType || '-'}
        </TableCellView>
      )}
      {columns.driverNote && (
        <TableCellView>
          {item.driverNote || '-'}
        </TableCellView>
      )}
      {columns.driver && (
        <TableCellView>
          {item.driver || '-'}
        </TableCellView>
      )}
      {columns.costCentre && (
        <TableCellView>
          {item.costCentre || '-'}
        </TableCellView>
      )}
      {columns.maturityDate && (
        <TableCellView>
          {item.maturityDate ? (
            <Label
              color={getDateColor(item.maturityDate)}
              variant="outlined">
              {moment(item.maturityDate).format('DD/MM/YY')}
            </Label>
          ) : '-'}
        </TableCellView>
      )}
      {columns.originalMaturityDate && (
        <TableCellView>
          {moment(item.originalMaturityDate).format('DD/MM/YY') || '-'}
        </TableCellView>
      )}
      {columns.term && (
        <TableCellView>
          {item.term || '-'}
        </TableCellView>
      )}
      {columns.currentTerm && (
        <TableCellView>
          {item.currentTerm || '-'}
        </TableCellView>
      )}
      {columns.monthsOnVerbal && (
        <TableCellView>
          {item.monthsOnVerbal || '-'}
        </TableCellView>
      )}
      {columns.status && (
        <TableCellView>
          {item.status || '-'}
        </TableCellView>
      )}
      {columns.documentsCount && (
        <TableCellView>
          {( item.documentsCount > 0 ? (
            <Tooltip title="View documents">
              <IconButton
                onClick={onViewDocumentsReport}>
                <InsertDriveFileOutlinedIcon sx={{ color: themeV5.palette.primary.main }}/>
              </IconButton>
            </Tooltip>
          ) : '-')}
        </TableCellView>
      )}
      {Object.values(columns).some(value => value === true) &&
        (<TableCellView isLast></TableCellView>)
      }
    </TableRow>
  )
}

Row.propTypes = {
  item: types.ModelType.isRequired,
  columns: types.ColumnsType.isRequired,
}

export default Row
